import(/* webpackMode: "eager" */ "/build/src/app/global-error.tsx");
